import { useRecoilValue } from 'recoil';
import { useStyles } from '../../../hooks/useStyles';
import { reportSearchTypeState, reportViewState } from '../../../storage/reports';
import { FloatingCardContent } from '../../layout/cards/FloatingCardContent';
import { FloatingCardsLayout } from '../../layout/FloatingCardsLayout';
import DeliveryReports from '../../reports/deliveryReport/DeliveryReports';
import DeliveryReportsByGroup from '../../reports/deliveryReport/DeliveryReportsByGroup';
import ReportsSharedWrapper from './ReportsSharedWrapper';

function DeliveryReportsPage() {
  const { theme } = useStyles();
  const reportView = useRecoilValue(reportViewState);
  const reportSearchType = useRecoilValue(reportSearchTypeState);
  const isGroupReportView = reportSearchType === 1 && reportView === 0;

  return (
    <FloatingCardsLayout
      content={
        <FloatingCardContent
          flexible
          gap={theme.sizing.scale600}
        >
          <ReportsSharedWrapper>
            {!isGroupReportView && <DeliveryReports />}
            {isGroupReportView && <DeliveryReportsByGroup />}
          </ReportsSharedWrapper>
        </FloatingCardContent>
      }
      contentSize={550}
    />
  );
}

export default DeliveryReportsPage;
